import { createClient } from "@smfa/utils";
const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;

const axios = createClient({
  baseUrl,
  isAdminSite: true,
});

export const getAboutBanner = ({ signal, ...params } = {}) => {
  const config = {};
  if (Object.keys(params).length > 0) config.params = params;
  if (signal) config.signal = signal;
  return axios.get("/about-banners", config);
};

export const updateAboutBanner = (data) => {
  return axios.post(`/updateaboutbanner`, data);
};

export const getAboutContent = (data) => {
  return axios.get("/get_about_who", data ? { params: data } : {});
};

export const updateAboutContent = (data) => {
  return axios.post(`/add_edit_about_who`, data);
};

export const updateAboutDirector = (data) => {
  return axios.post(`/updateaboutdirectory`, data);
};

export const getAboutDirector = (data) => {
  return axios.get("/about-directories", data ? { params: data } : {});
};

export const saveDirector = (data) => {
  return axios.post(`/saveDirector`, data);
};

export const getDirectorList = (data) => {
  return axios.post(`/directors`, data);
};

export const getDirectorOrderList = (data) => {
  return axios.post(`/directors_data`, data);
};

export const saveStory = (data) => {
  return axios.post(`/add_edit_about_stories`, data);
};

export const getStoryList = (data) => {
  return axios.post(`/get_about_stories_list`, data);
};

export const deleteDirector = (data) => {
  return axios.post(`/delete_director`, data);
};

export const deleteStory = (data) => {
  return axios.post(`/delete_stories`, data);
};
